import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        //获取代理商列表(续订资源包)
        getAgentList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
            };
            //过滤没有查询的值传入服务器
            for (var i in this.query) {
                if (this.query.hasOwnProperty(i)) {
                    if (isCorrectVal(this.query[i])) {
                        params[i] = this.query[i]
                    }
                };
            }
            let $href = "api/MeetOrder/GetMeetLinkAgentList"

            if (this.isNotHX || this.isContinuePackage) {
                //获取代理商列表(续班订单)
                // params.ProjectTypes = 3
                // $href = "api/ContinueOrder/GetAgentList"
                $href = "api/Common/GetAgentList"
            } else if (this.isKaike) {
                // 转会销代理商接口 GetContinueResourceAgentList   agentType=2 
                params.agentType = 2
                $href = "api/MeetOrder/GetContinueResourceAgentList"
            } else {
                $href = "api/MeetOrder/GetMeetLinkAgentList"
            }

            this.loading = true;
            $http.get($href, params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.lists = Data;
                    this.totalSize = Cnt;
                });
            });
        },


        // 获取园所列表
        getSchoolList(agentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                AgentId: agentId
            };
            //过滤没有查询的值传入服务器
            for (var i in this.query) {
                if (this.query.hasOwnProperty(i)) {
                    if (isCorrectVal(this.query[i])) {
                        params[i] = this.query[i]
                    }
                };
            }
            let $href = "api/MeetOrder/GetMeetLinkSchoolList"
            if (this.isNotHX) {
                // 续班订单获取园所接口
                params.ProjectTypes = this.ProjectType
                $href = 'api/ContinueOrder/GetSchoolList'
            } else if (this.isContinuePackage) {
                // 续订资源包调用的
                $href = "api/Common/GetSchoolList"
            } else if (this.isKaike || this.isSchoolKaike) {
                // 转会销开课和转园开课
                $href = "api/Common/GetSchoolList"
            } else {
                $href = "api/MeetOrder/GetMeetLinkSchoolList"
            }

            this.loading = true;
            $http.get($href, params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.lists = Data;
                    this.totalSize = Cnt;
                });
            });
        },

    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/chooseDialog/services.js